// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as GraphRouteImport } from './routes/graph'
import { Route as EpisodesRouteImport } from './routes/episodes'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BooksIndexRouteImport } from './routes/books.index'
import { Route as BooksSlugRouteImport } from './routes/books.$slug'

const GraphRoute = GraphRouteImport.update({
            id: '/graph',path: '/graph',getParentRoute: () => rootRouteImport
          })
const EpisodesRoute = EpisodesRouteImport.update({
            id: '/episodes',path: '/episodes',getParentRoute: () => rootRouteImport
          })
const ChatRoute = ChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BooksIndexRoute = BooksIndexRouteImport.update({
            id: '/books/',path: '/books/',getParentRoute: () => rootRouteImport
          })
const BooksSlugRoute = BooksSlugRouteImport.update({
            id: '/books/$slug',path: '/books/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRoute: AuthRoute,ChatRoute: ChatRoute,EpisodesRoute: EpisodesRoute,GraphRoute: GraphRoute,BooksSlugRoute: BooksSlugRoute,BooksIndexRoute: BooksIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)